import { load } from 'recaptcha-v3';
import BaseRecaptchaInstance from './base_instance';

class LazyRecaptchaProxy extends BaseRecaptchaInstance {
  constructor() {
    super();
    this.internalInstance = null;
  }

  buildInternalInstance() {
    return new Promise((resolve, reject) => {
      const settings = { useRecaptchaNet: true, autoHideBadge: true };
      load(process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY, settings).then(resolve).catch(reject);
    });
  }

  getInternalInstance() {
    return new Promise((resolve, reject) => {
      if (this.internalInstance) {
        resolve(this.internalInstance);
      } else {
        const resolverProxy = (instance) => {
          this.internalInstance = instance;
          resolve(instance);
        };
        this.buildInternalInstance().then(resolverProxy).catch(reject);
      }
    });
  }

  reset = () => {
    this.internalInstance = null;
  };

  execute = (action) => {
    return new Promise((resolve, reject) => {
      this.getInternalInstance()
        .then(instance => {
          instance.execute(action).then(resolve).catch(reject);
        })
        .catch(reject);
    });
  };

  executeWithRetries = async (action, retries = 3) => {
    const adjustedRetries = retries >= 1 ? retries : 1;
    let recaptchaTriesLeft = adjustedRetries;
    let recaptchaToken = null;
    while (recaptchaTriesLeft > 0) {
      --recaptchaTriesLeft;
      console.log('Trying to get ReCaptcha token...');
      try {
        recaptchaToken = await this.execute(action);
        break;
      } catch (error) {
        // An error was thrown while acquiring a token, so print it.
        // We also have to reset the ReCaptcha instance because we may have a badly loaded recaptcha object.
        console.log(error);
        recaptchaToken = null;
        this.reset();
      }
    }
    if (recaptchaToken) return recaptchaToken;
    throw new Error('Failing to connect to ReCaptcha.');
  };

  getSiteKey = () => process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;

  hideBadge = () => {
    return new Promise((resolve, reject) => {
      this.getInternalInstance()
        .then(instance => {
          instance.hideBadge().then(resolve).catch(reject);
        })
        .catch(reject);
    });
  };

  showBadge = () => {
    return new Promise((resolve, reject) => {
      this.getInternalInstance()
        .then(instance => {
          instance.showBadge().then(resolve).catch(reject);
        })
        .catch(reject);
    });
  };
}

export default LazyRecaptchaProxy;
